import { useEffect } from 'react';

import { ThemeMode, applyTheme } from './useDarkModeToggle';

const usePersistedTheme = () => {
  useEffect(() => {
    const stored = localStorage.getItem('theme');
    const mode: ThemeMode =
      stored === 'light' || stored === 'dark' ? stored : 'system';
    applyTheme(mode);
  }, []);
};

export default usePersistedTheme;
